import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@app/layouts/public-main/header/header.component';
import { NzContentComponent, NzLayoutComponent } from 'ng-zorro-antd/layout';
import { PublicMainLayoutService } from '@app/layouts/public-main/layout/public-main-layout.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'math-public-main-layout',
  imports: [
    RouterOutlet,
    HeaderComponent,
    NzLayoutComponent,
    NzContentComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './public-main-layout.component.html',
  styleUrl: './public-main-layout.component.scss',
})
export class PublicMainLayoutComponent {
  protected publicMainLayoutService = inject(PublicMainLayoutService);
}
